import { AutogenModelReportProperty, AutogenRowReportProperty } from "./autogen/AutogenModelReportProperty";

export class ModelReportProperty extends AutogenModelReportProperty<RowReportProperty> {
	constructor() {
		super(RowReportProperty);
	}
}

export class RowReportProperty extends AutogenRowReportProperty {
}